import { PRODUCT_TYPES, putOrg } from '@moal/api'
import { useContext, useEffect, useState } from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import { SiteConfigContext } from '../../../context/siteConfigContext'
import { toastError, toastSuccess } from '../../../utils/toast'
import './styles.css'

const PolicyEditor = ({ title, fieldKey }) => {
  const { productsService } = useContext(SiteConfigContext)
  const [org, setOrg] = useState(productsService[PRODUCT_TYPES.ORG])
  const [policy, setPolicy] = useState({})
  const [content, setContent] = useState({ url: '', html: '' })

  useEffect(() => {
    if (productsService) {
      setOrg(productsService[PRODUCT_TYPES.ORG])
      const policies = productsService[PRODUCT_TYPES.ORG].policies || {}
      setPolicy(policies)
      setContent(policies[fieldKey] || { url: '', html: '' })
    }
  }, [productsService])

  const handleSubmit = async (e) => {
    e.preventDefault()
    const updatedProduct = {
      ...org,
      policies: {
        ...policy,
        [fieldKey]: content
      }
    }

    const response = await putOrg({
      token: localStorage.getItem('authToken'),
      data: updatedProduct
    })

    if (response && response.status === 200) {
      toastSuccess(`${title} saved successfully`)
      // products socket doesn't exist here so if you don't reload after updating it gets weird
      window.location.reload()
    } else {
      toastError(`Failed to save ${title}`)
    }
  }

  const handleQuillChange = (value) => {
    setContent((current) => ({ ...current, html: value }))
  }

  return (
    <form
      onSubmit={handleSubmit}
      autoComplete="off"
      className="flex flex-col gap-2"
    >
      <h3>
        If a URL is provided, an iFrame will be rendered; otherwise, the
        provided HTML will be displayed.
      </h3>
      <h2>URL</h2>
      <input
        id="url"
        name="url"
        value={content.url}
        onChange={(e) =>
          setContent((current) => ({ ...current, url: e.target.value }))
        }
        className="input block w-full"
        placeholder={`${title} URL`}
      />
      <h2>Rich Text</h2>
      <ReactQuill
        id="html"
        name="html"
        style={{ height: '420px', width: '100%' }}
        aria-label={`${title} content`}
        placeholder={`${title} HTML`}
        value={content.html}
        onChange={handleQuillChange}
        modules={{
          toolbar: [
            [{ header: [1, 2, false] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['link'],
            ['clean']
          ]
        }}
        formats={[
          'header',
          'bold',
          'italic',
          'underline',
          'strike',
          'blockquote',
          'list',
          'bullet',
          'link'
        ]}
      />
      <button type="submit" aria-label="Save" className="button-confirm w-fit">
        Save
      </button>
    </form>
  )
}

export default PolicyEditor
